import { MessageFile, PostMessageFileData } from "../../types";

const getSendMessageFileData = (
  message: MessageFile,
  file: File
): PostMessageFileData => {
  const {
    authorId: strAuthorId,
    content: { text },
    replyMessage,
    traceId,
  } = message;

  const authorId = Number(strAuthorId);

  const strReplyMessageId = replyMessage?.id;

  return strReplyMessageId
    ? {
        authorId,
        file,
        traceId,
        text,
        replyMessageId: Number(strReplyMessageId),
      }
    : {
        authorId,
        file,
        traceId,
        text,
      };
};

export { getSendMessageFileData };
